import { render, staticRenderFns } from "./BookingPaymentsDataTable.vue?vue&type=template&id=796d5150"
import script from "./BookingPaymentsDataTable.vue?vue&type=script&lang=js"
export * from "./BookingPaymentsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports